import { CheckCircle, XCircle, AlertCircle, Clock, Hourglass } from 'lucide-react';

// Valeurs canoniques alignées sur l'enum backend StatutPresence
// (cf. backend/models/enums.py).
export const STATUTS_PRESENCE = {
  'non_defini': {
    label: 'Non défini',
    color: 'bg-slate-100 text-slate-600 border-slate-300',
    icon: Clock,
    requiresAction: true
  },
  'present': {
    label: 'Présent',
    color: 'bg-emerald-100 text-emerald-700 border-emerald-300',
    icon: CheckCircle,
    requiresSignature: true
  },
  'absent_justifie': {
    label: 'Absence justifiée',
    color: 'bg-amber-100 text-amber-700 border-amber-300',
    icon: AlertCircle,
    requiresJustificatif: true
  },
  'absent_non_justifie': {
    label: 'Absent',
    color: 'bg-red-100 text-red-700 border-red-300',
    icon: XCircle
  }
};

// Statut d'affichage spécial : absence portée par l'intervenant mais justificatif pas encore fourni
// → on affiche "En attente" sur la feuille d'émargement (≠ absence confirmée)
export const STATUT_EN_ATTENTE_JUSTIFICATIF = {
  label: 'En attente de justificatif',
  color: 'bg-orange-100 text-orange-700 border-orange-300',
  icon: Hourglass,
  requiresJustificatif: true
};

/**
 * Retourne le statut d'affichage effectif d'un participant.
 * Règle : si l'intervenant a "porté l'absence" (absent_justifie)
 * mais que le participant n'a pas encore fourni de justificatif,
 * le statut affiché sur la feuille est "En attente".
 */
export const getDisplayStatut = (participant) => {
  if (
    participant.statut_presence === 'absent_justifie' &&
    !participant.justificatif_id
  ) {
    return STATUT_EN_ATTENTE_JUSTIFICATIF;
  }
  return STATUTS_PRESENCE[participant.statut_presence] || STATUTS_PRESENCE['non_defini'];
};

export const ROLE_LABELS = {
  'financeur': 'Financeur',
  'referent': 'Référent',
  'animateur': 'Intervenant',
  'alliance': 'Intervenant',  // Mapping pour ancienne valeur
  'Alliance': 'Intervenant'   // Mapping pour ancienne valeur
};

export const ROLE_BADGE_COLORS = {
  'financeur': 'bg-purple-100 text-purple-700',
  'referent': 'bg-green-100 text-green-700',
  'animateur': 'bg-blue-100 text-blue-700',
  'alliance': 'bg-blue-100 text-blue-700',  // Mapping pour ancienne valeur
  'Alliance': 'bg-blue-100 text-blue-700'   // Mapping pour ancienne valeur
};

export const getRoleLabel = (role) => ROLE_LABELS[role] || role;
export const getRoleBadgeColor = (role) => ROLE_BADGE_COLORS[role] || 'bg-slate-100 text-slate-700';
